import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons';

import OrderForm from './OrderForm';

const HeaderMenu = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderFormVisible, setOrderFormVisible] = useState(false);

  const handleOpenOrderForm = () => {
    setOrderFormVisible(true);
  };
  const handleCloseOrderForm = () => {
    setOrderFormVisible(false);
  };
  const handleOrderSuccess = () => {
    setOrderFormVisible(false);
    // Optionally, trigger a refresh elsewhere if needed
  };

  return (
    <div style={{
      width: '100%',
      background: 'white',
      borderBottom: '1px solid #eee',
      padding: '16px 0',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <button
          onClick={() => navigate('/current-positions')}
          style={{
            background: location.pathname === '/current-positions' ? 'black' : 'white',
            color: location.pathname === '/current-positions' ? 'white' : 'black',
            border: '1px solid black',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 16,
            padding: '8px 24px',
            marginRight: 16,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          Positions
        </button>
        <button
          onClick={() => navigate('/orders')}
          style={{
            background: location.pathname === '/orders' ? 'black' : 'white',
            color: location.pathname === '/orders' ? 'white' : 'black',
            border: '1px solid black',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 16,
            padding: '8px 24px',
            marginRight: 24,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          Orders
        </button>
        {/* Place Order Button */}
        <button
          onClick={handleOpenOrderForm}
          style={{
            background: 'black',
            color: 'white',
            border: '1px solid black',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 16,
            padding: '8px 24px',
            marginRight: 24,
            marginLeft: 46,

            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
        >
          Place Order
        </button>
      </div>
      <button
        onClick={onLogout}
        style={{
          background: 'black',
          color: 'white',
          border: '1px solid black',
          borderRadius: 6,
          fontWeight: 600,
          fontSize: 16,
          padding: '8px 20px',
          position: 'absolute',
          right: 24,
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          transition: 'all 0.2s',
        }}
        title="Logout"
      >
        <LogoutOutlined style={{ fontSize: 18, marginRight: 8 }} /> Logout
      </button>
      {/* Order Form Modal (global, not page-specific) */}
      <OrderForm
        visible={orderFormVisible}
        onClose={handleCloseOrderForm}
        onOrderSuccess={handleOrderSuccess}
        editingOrder={null}
      />
    </div>
  );
};

export default HeaderMenu;